// document.addEventListener('DOMContentLoaded', function() {
//     document.querySelectorAll('.OrderCancelButton').forEach(button => {
//         button.addEventListener('click', function() {
//             const orderId = this.getAttribute('data-order-id');
            
//             if (!orderId) {
//                 console.error('Order ID not found');
//                 return;
//             }

//             var settings = {
//                 "url": `https://5cd81b-1f.myshopify.com/admin/api/2024-07/orders/${orderId}/cancel.json`,
//                 "method": "POST",
//                 "timeout": 0,
//                 "headers": {
//                     "X-Shopify-Access-Token": "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",
//                     "Content-Type": "application/json"
//                 },
//             };

//             $.ajax(settings).done(function(response) {
//                 console.log(response);
//                 alert('Order canceled successfully!');
//             }).fail(function(response) {
//                 console.error(response);
//                 alert('Failed to cancel the order.');
//             });
//         });
//     });
// });
// $('.featured-product .product__media-list').slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           infinite: false,
//           dots: false
//         }
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });

// if (window.location.pathname.includes('/cart')) {
//   console.log("Cart page detected");

//   // Prevent drawer open completely
//   $('#cart-icon-bubble').on('click', function (e) {
//     e.preventDefault();
//     e.stopImmediatePropagation(); // Stops ALL other handlers, including Shopify’s own
//     return false;
//   });

//   // Optional: Also remove body overflow and close any open drawer
//   const $drawer = $('cart-drawer');
//   if ($drawer.length && $drawer.hasClass('active')) {
//     $drawer.removeClass('active');
//     $('body').removeClass('overflow-hidden');
//   }
// }

  function disableCartLinkIfOnCartPage() {
    if (window.location.pathname === '/cart') {
      const cartLink = document.querySelector('a#cart-icon-bubble[href="/cart"]');

      if (cartLink) {
        // Prevent default click behavior
        cartLink.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
        });

        // Optional: visually indicate it's inactive
        cartLink.style.pointerEvents = 'none';
      
        cartLink.style.cursor = 'default';
        cartLink.removeAttribute('href');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Initial call
    disableCartLinkIfOnCartPage();

    // Fallback in case Shopify renders the cart icon later
    setTimeout(disableCartLinkIfOnCartPage, 500);
  });


